/**
 * カート件数の更新処理
 * サンキューページから遷移した際にカート件数が0になる問題を修正
 */
(function($) {
    'use strict';

    /**
     * ページ読み込み時にカート件数を更新
     */
    function updateCartCount() {
        // カートデータを取得
        fetch('/cart.js')
            .then(response => response.json())
            .then(data => {
                const count = data.item_count || 0;

                // デスクトップ版のカウンターを更新（括弧付き）
                const $counterDesktop = $('[data-js-cart-count-desktop]');
                if ($counterDesktop.length) {
                    $counterDesktop.attr('data-js-cart-count-desktop', count).html('(' + count + ')');
                }

                // モバイル版のカウンターを更新（数字のみ）
                const $counterMobile = $('[data-js-cart-count-mobile]');
                if ($counterMobile.length) {
                    $counterMobile.attr('data-js-cart-count-mobile', count).html(count);
                }
            })
            .catch(error => {
                console.error('カート件数の更新に失敗しました:', error);
            });
    }

    // ページ読み込み完了後に実行
    $(document).ready(function() {
        // 少し遅延させて実行（theme.jsの初期化後に実行するため）
        setTimeout(updateCartCount, 100);
    });

})(jQueryTheme || jQuery);
